import OutlinedInput, {
  type OutlinedInputProps,
} from '@mui/material/OutlinedInput';
import { SearchIcon } from '@tyro/icons';
import { useSearchProvider } from './provider';

interface SearchInputProps extends Omit<OutlinedInputProps, 'onChange'> {
  value: string;
  onChange: (value: string) => void;
  ariaControls: string;
  ariaExpanded: boolean;
}

export function SearchInput({
  value,
  onChange,
  ariaControls,
  ariaExpanded,
  ...props
}: SearchInputProps) {
  const { nextOption, previousOption, navigateToSelectedOption } =
    useSearchProvider();

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      nextOption();
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      previousOption();
    } else if (event.key === 'Enter') {
      event.preventDefault();
      navigateToSelectedOption();
    }
  };

  return (
    <OutlinedInput
      role="combobox"
      autoCorrect="off"
      autoComplete="off"
      aria-controls={ariaControls}
      aria-expanded={ariaExpanded}
      autoFocus
      startAdornment={<SearchIcon sx={{ mr: 1 }} />}
      placeholder="Search for students, staff and more..."
      value={value}
      onChange={(event) => {
        onChange(event.target.value);
      }}
      onKeyDown={handleKeyDown}
      sx={{
        width: '100%',
        '& fieldset': {
          border: 'none',
        },
      }}
      {...props}
    />
  );
}
